/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NotificationAppIcon24Regular = forwardRef('NotificationAppIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.5.75a4.75 4.75 0 1 0 0 9.5 4.75 4.75 0 0 0 0-9.5ZM15.25 5.5a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Z" }),
        React.createElement("path", { d: "M3.75 6.5A2.75 2.75 0 0 1 6.5 3.75h5.25a.75.75 0 0 0 0-1.5H6.5A4.25 4.25 0 0 0 2.25 6.5v11a4.25 4.25 0 0 0 4.25 4.25h11a4.25 4.25 0 0 0 4.25-4.25v-5.25a.75.75 0 0 0-1.5 0v5.25a2.75 2.75 0 0 1-2.75 2.75h-11a2.75 2.75 0 0 1-2.75-2.75v-11Z" })));
});
